import { queryOptions } from '@tanstack/react-query';

import { STANDARD_STALE_TIME } from '$/services/constants';
import {
  getAllSchoolClasses,
  getSchoolClassById,
  getSchoolClassProjects,
} from '$/services/usecases/school/schoolClasses';
import {
  getAllSchools,
  getSchoolById,
  getTeachersBySchoolId,
} from '$/services/usecases/school/schools';
import { getAllStudents } from '$/services/usecases/school/students';

export const studentsQuery = queryOptions({
  queryKey: ['students'],
  queryFn: ({ signal }) => getAllStudents(signal),
  staleTime: STANDARD_STALE_TIME,
});

export const schoolClassQuery = (id?: string) =>
  queryOptions({
    queryKey: ['schoolClass', id],
    queryFn: ({ signal }) => getSchoolClassById(signal, id),
    staleTime: STANDARD_STALE_TIME,
    enabled: id != null,
  });

export const schoolClassesQuery = (isDisabled = false) =>
  queryOptions({
    queryKey: ['schoolClass'],
    queryFn: ({ signal }) => getAllSchoolClasses(signal),
    staleTime: STANDARD_STALE_TIME,
    enabled: !isDisabled,
  });

export const schoolClassProjectsQuery = (id: string) =>
  queryOptions({
    queryKey: ['schoolClass', id],
    queryFn: ({ signal }) => getSchoolClassProjects(signal, id),
    staleTime: STANDARD_STALE_TIME,
  });

export const schoolsQuery = queryOptions({
  queryKey: ['schools'],
  queryFn: ({ signal }) => getAllSchools(signal),
  staleTime: STANDARD_STALE_TIME,
});

export const schoolQuery = (id?: string) =>
  queryOptions({
    queryKey: ['schools', id],
    queryFn: ({ signal }) => getSchoolById(signal, id!),
    staleTime: STANDARD_STALE_TIME,
    enabled: id != null,
  });

export const schoolTeachersQuery = (id?: string) =>
  queryOptions({
    queryKey: ['schools', id, 'teachers'],
    queryFn: ({ signal }) => getTeachersBySchoolId(signal, id!),
    staleTime: STANDARD_STALE_TIME,
    enabled: id != null,
  });
